import { publicLinkPageOf } from "@shared/publicLinks";
import "./index.css";
import { routeAfterFreshPwaEntry } from "@/lib/applyPwaUpdate";

// The update button enters through a route that even the previous worker
// fetches from the network, then restores the user's original CRM address
// before React and its router mount. No additional page reload is needed.
const returnAfterPwaUpdate = routeAfterFreshPwaEntry(
  window.location.pathname,
  window.location.search,
  window.location.origin
);
if (returnAfterPwaUpdate) {
  window.history.replaceState(window.history.state, "", returnAfterPwaUpdate);
}

// A candidate needs only the invitation and call, not the CRM dashboard or
// Firebase sign-in. Keep this entry tiny so it can choose the right bootstrap
// before the browser downloads the application code.
const entry =
  publicLinkPageOf(window.location.pathname) === "videoInterview"
    ? import("./candidateInterviewMain")
    : import("./crmMain");

void entry.catch(() => {
  const root = document.getElementById("root");
  if (!root) return;
  const message = document.createElement("div");
  message.style.cssText =
    "min-height:100svh;display:flex;align-items:center;justify-content:center;padding:24px;background:#f5f5f7;color:#1d1d1f;font:15px/1.5 system-ui,sans-serif;text-align:center";
  message.textContent =
    "Не удалось открыть страницу. Проверьте интернет и обновите её.";
  root.replaceChildren(message);
});
